module.exports = __webpack_public_path__ + "static/media/commerciale-affitto.66615aba.jpg";